import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=1924758e&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=1924758e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1924758e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1924758e')) {
      api.createRecord('1924758e', component.options)
    } else {
      api.reload('1924758e', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=1924758e&scoped=true&", function () {
      api.rerender('1924758e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lbuk5VZWZ3dF/JS/comp/GuestBoxKids.vue"
export default component.exports